/* DO NOT EDIT! This file is auto-generated by graphql-code-generator - see `codegen.ts` */
/* eslint-disable */
// noinspection JSUnusedGlobalSymbols, DuplicatedCode

import * as Types from '__generated__/graphql.ts';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type GetLocationAvailabilitiesQueryVariables = Types.Exact<{
  search: Types.LocationAvailabilitySearch;
}>;


export type GetLocationAvailabilitiesQuery = {
  __typename?: 'Query',
  locationAvailabilities: Array<{
    __typename?: 'LocationAvailability',
    id: number,
    fromDateTime: number,
    toDateTime: number,
    type: Types.LocationAvailabilityType,
    craneSpeed?: number | null,
    amountOfCranes?: number | null,
    maxWidthInMeters?: number | null,
    canHandleOOG?: boolean | null,
    canHandleBundles?: boolean | null,
    twinningAllowed?: boolean | null,
    fullContainersAllowed?: boolean | null,
    location: {
      __typename?: 'Location',
      id: number,
      description: string
    },
    bolderFrom: {
      __typename?: 'Bolder',
      id: number,
      description?: string | null,
      sequenceNumber?: number | null,
      quay: {
        __typename?: 'Quay',
        id: number
      }
    },
    bolderTo: {
      __typename?: 'Bolder',
      id: number,
      description?: string | null,
      sequenceNumber?: number | null
    },
    crane?: {
      __typename?: 'Crane',
      id?: number | null,
      name?: string | null,
      craneType?: Types.CraneType | null
    } | null,
    overflowLocations?: Array<{
      __typename?: 'Location',
      id: number,
      description: string
    }> | null
  }>
};

export type GetLocationAvailabilityQueryVariables = Types.Exact<{
  id: Types.Scalars['Long']['input'];
}>;


export type GetLocationAvailabilityQuery = {
  __typename?: 'Query',
  locationAvailability: {
    __typename?: 'LocationAvailability',
    id: number,
    fromDateTime: number,
    toDateTime: number,
    type: Types.LocationAvailabilityType,
    craneSpeed?: number | null,
    amountOfCranes?: number | null,
    maxWidthInMeters?: number | null,
    canHandleOOG?: boolean | null,
    canHandleBundles?: boolean | null,
    twinningAllowed?: boolean | null,
    fullContainersAllowed?: boolean | null,
    bolderFrom: {
      __typename?: 'Bolder',
      id: number,
      description?: string | null
    },
    bolderTo: {
      __typename?: 'Bolder',
      id: number,
      description?: string | null
    },
    crane?: {
      __typename?: 'Crane',
      id?: number | null,
      name?: string | null,
      craneType?: Types.CraneType | null,
      handlingRates?: Array<{
        __typename?: 'CraneProductHandlingRate',
        id?: number | null,
        handlingRateInTonsPerHour?: number | null,
        product?: {
          __typename?: 'Product',
          id: number,
          name: string,
          code?: string | null
        } | null
      }> | null
    } | null,
    overflowLocations?: Array<{
      __typename?: 'Location',
      id: number,
      description: string
    }> | null
  }
};


export const GetLocationAvailabilitiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLocationAvailabilities"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LocationAvailabilitySearch"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationAvailabilities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fromDateTime"}},{"kind":"Field","name":{"kind":"Name","value":"toDateTime"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"craneSpeed"}},{"kind":"Field","name":{"kind":"Name","value":"bolderFrom"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"sequenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"quay"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"bolderTo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"sequenceNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"crane"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"craneType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"amountOfCranes"}},{"kind":"Field","name":{"kind":"Name","value":"maxWidthInMeters"}},{"kind":"Field","name":{"kind":"Name","value":"canHandleOOG"}},{"kind":"Field","name":{"kind":"Name","value":"canHandleBundles"}},{"kind":"Field","name":{"kind":"Name","value":"twinningAllowed"}},{"kind":"Field","name":{"kind":"Name","value":"fullContainersAllowed"}},{"kind":"Field","name":{"kind":"Name","value":"overflowLocations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]} as unknown as DocumentNode<GetLocationAvailabilitiesQuery, GetLocationAvailabilitiesQueryVariables>;
export const GetLocationAvailabilityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLocationAvailability"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationAvailability"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fromDateTime"}},{"kind":"Field","name":{"kind":"Name","value":"toDateTime"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"craneSpeed"}},{"kind":"Field","name":{"kind":"Name","value":"bolderFrom"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"bolderTo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"crane"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"craneType"}},{"kind":"Field","name":{"kind":"Name","value":"handlingRates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"handlingRateInTonsPerHour"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"amountOfCranes"}},{"kind":"Field","name":{"kind":"Name","value":"maxWidthInMeters"}},{"kind":"Field","name":{"kind":"Name","value":"canHandleOOG"}},{"kind":"Field","name":{"kind":"Name","value":"canHandleBundles"}},{"kind":"Field","name":{"kind":"Name","value":"twinningAllowed"}},{"kind":"Field","name":{"kind":"Name","value":"fullContainersAllowed"}},{"kind":"Field","name":{"kind":"Name","value":"overflowLocations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]} as unknown as DocumentNode<GetLocationAvailabilityQuery, GetLocationAvailabilityQueryVariables>;